import { IconsProps } from '@/types/shared'

const WarehouseIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22 21V7L12 2L2 7V21H10V14H14V21H22ZM12 4.68L20 8.54V19H16V12H8V19H4V8.54L12 4.68ZM7 8H9V10H7V8ZM11 8H13V10H11V8ZM15 8H17V10H15V8Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default WarehouseIcons
